import React from "react";
import { userSiteAsset } from "../../../utils/userSiteAssets";
import {
  formatRangeVal,
  getExposure,
  bookClass,
  bookText,
  isSuspended,
} from "../../casinoComponents/userSiteLastResult/refUtils";

const FIGHT = userSiteAsset("assets/img/fight.png");

/**
 * 1 Card Meter (cmeter1) bet area in the reference markup (inside .casino-detail):
 *   .meter-btns > 2 × .meter-btn (.min-max, .meter-btn-box(.suspended) > button.btn-fighter-N, book)
 */
export default function Cmeter1Table({ raw = {}, exposures = {} }) {
  const sub = Array.isArray(raw?.sub) ? raw.sub : [];
  const main = sub
    .filter((s) => !s?.subtype || s.subtype === "cmeter1")
    .sort((a, b) => Number(a?.sr) - Number(b?.sr));
  if (main.length === 0) return null;

  const btn = (item, n) => {
    const exp = getExposure(exposures, item?.nat);
    const susp = isSuspended(item);
    const img = <img src={FIGHT} alt="Fight" />;
    return (
      <div className="meter-btn">
        <div className="text-right min-max">
          {"\n                                    Min:"}
          <span>{formatRangeVal(item?.min)}</span>
          {"\n                                    Max:"}
          <span>{formatRangeVal(item?.max)}</span>
        </div>{" "}
        <div className={`meter-btn-box${susp ? " suspended" : ""}`}>
          {n === 1 ? (
            <button type="button" className="btn btn-fighter-1">
              {`\n                                        ${item?.nat ?? ""}\n                                        `}
              {img}
            </button>
          ) : (
            <button type="button" className={`btn btn-fighter-2${susp ? " suspended" : ""}`}>
              {img}
              {`\n                                        ${item?.nat ?? ""}\n                                    `}
            </button>
          )}
        </div>{" "}
        <div className="book-green text-center">
          <b className={bookClass(exp)}>{bookText(exp)}</b>
        </div>
      </div>
    );
  };

  return (
    <div className="meter-btns">
      {btn(main[0], 1)} {btn(main[1], 2)}
    </div>
  );
}
